import { HttpHeaders } from "@angular/common/http";
import { CheckoutDTO } from "../../../shared/checkout-dto";

export const COORDS_TO_MILES = .016
export const MIN_LOAD_TIME = 250
export const DEFAULT_NEWS_IMAGE = '/assets/images/logo_header.png'


export const STORAGE_WHOLESALE_REDIRECT = 'pv-wholesale-redirect';
export const STORAGE_SPLASH_PAGE = 'pv-splash-04';
export const STORAGE_REDIRECT = 'pv-redirect';
export const STORAGE_SPOTIFY = 'pv-spotify';
export const STORAGE_CUSTOMER = 'pv-customer';
export const STORAGE_CMS = 'pv-cms';
export const STORAGE_CUSTOMER_JWT = 'jwt-customer';
export const STORAGE_CMS_JWT = 'jwt-cms';
export const STORAGE_TRACK = 'track_ids';
export function tokenGetter() {
  try {
    if (location.pathname.substring(0, 4) == '/cms') {
      return localStorage.getItem(STORAGE_CMS_JWT)
    } else {
      return localStorage.getItem(STORAGE_CUSTOMER_JWT)
    }
  } catch(e) {
    return null;
  }
};
export const STORAGE_REFRESH_CUSTOMER_DATE = 'refresh_date';
export const STORAGE_REFRESH_CMS_DATE = 'refresh_date';
export const CART_COOKIE = 'cart'
export const DEFAULT_CHECKOUT_DTO: CheckoutDTO = {
    payload: null,
    useCredits: false,
    shippingRate1: null,
    shippingRate2: null,
    billingAddress: null,
    coupon: null,
    customer: {
      id: null,
      email: '',
      company: '',
      ship_firstname: null,
      ship_lastname: null,
      ship_addr1: null,
      ship_addr2: null,
      ship_city: null,
      ship_state: null,
      ship_zip: null,
      ship_country_iso: null,
      ship_phone: null,
      is_wholesale: null,
      delayed_payment_days: null,
    },
    cart: {
      taxAmount: 0,
      loyaltyPoints: 0,
      separate: false,
      cartKey: null,
      bonus: [],
      items: [],
      isPhysical: null,
      totalOriginal: 0,
      totalPretax: 0,
      preorderDate: null,
    }
}

export const US_STATES_OPTIONS = [
  { abbr: 'AL', label: 'Alabama' },
  { abbr: 'AK', label: 'Alaska' },
  { abbr: 'AS', label: 'American Samoa' },
  { abbr: 'AZ', label: 'Arizona' },
  { abbr: 'AR', label: 'Arkansas' },
  { abbr: 'AE', label: 'Armed Forces Canada/Europe'},
  { abbr: 'AA', label: 'Armed Forces Americas (except Canada)'},
  { abbr: 'AP', label: 'Armed Forces Pacific' },
  { abbr: 'CA', label: 'California' },
  { abbr: 'CO', label: 'Colorado' },
  { abbr: 'CT', label: 'Connecticut' },
  { abbr: 'DE', label: 'Delaware' },
  { abbr: 'DC', label: 'District of Columbia' },
  { abbr: 'FM', label: 'Federated States of Micronesia' },
  { abbr: 'FL', label: 'Florida' },
  { abbr: 'GA', label: 'Georgia' },
  { abbr: 'GU', label: 'Guam' },
  { abbr: 'HI', label: 'Hawaii' },
  { abbr: 'ID', label: 'Idaho' },
  { abbr: 'IL', label: 'Illinois' },
  { abbr: 'IN', label: 'Indiana' },
  { abbr: 'IA', label: 'Iowa' },
  { abbr: 'KS', label: 'Kansas' },
  { abbr: 'KY', label: 'Kentucky' },
  { abbr: 'LA', label: 'Louisiana' },
  { abbr: 'ME', label: 'Maine' },
  { abbr: 'MH', label: 'Marshall Islands' },
  { abbr: 'MD', label: 'Maryland' },
  { abbr: 'MA', label: 'Massachusetts' },
  { abbr: 'MI', label: 'Michigan' },
  { abbr: 'MN', label: 'Minnesota' },
  { abbr: 'MS', label: 'Mississippi' },
  { abbr: 'MO', label: 'Missouri' },
  { abbr: 'MT', label: 'Montana' },
  { abbr: 'NE', label: 'Nebraska' },
  { abbr: 'NV', label: 'Nevada' },
  { abbr: 'NH', label: 'New Hampshire' },
  { abbr: 'NJ', label: 'New Jersey' },
  { abbr: 'NM', label: 'New Mexico' },
  { abbr: 'NY', label: 'New York' },
  { abbr: 'NC', label: 'North Carolina' },
  { abbr: 'ND', label: 'North Dakota' },
  { abbr: 'MP', label: 'Northern Mariana Islands' },
  { abbr: 'OH', label: 'Ohio' },
  { abbr: 'OK', label: 'Oklahoma' },
  { abbr: 'OR', label: 'Oregon' },
  { abbr: 'PW', label: 'Palau' },
  { abbr: 'PA', label: 'Pennsylvania' },
  { abbr: 'PR', label: 'Puerto Rico' },
  { abbr: 'RI', label: 'Rhode Island' },
  { abbr: 'SC', label: 'South Carolina' },
  { abbr: 'SD', label: 'South Dakota' },
  { abbr: 'TN', label: 'Tennessee' },
  { abbr: 'TX', label: 'Texas' },
  { abbr: 'UT', label: 'Utah' },
  { abbr: 'VT', label: 'Vermont' },
  { abbr: 'VI', label: 'Virgin Islands' },
  { abbr: 'VA', label: 'Virginia' },
  { abbr: 'WA', label: 'Washington' },
  { abbr: 'WV', label: 'West Virginia' },
  { abbr: 'WI', label: 'Wisconsin' },
  { abbr: 'WY', label: 'Wyoming' }]

  export const CANADA_STATE_OPTIONS = [
  { abbr: 'AB', label: 'Alberta', canada: true },
  { abbr: 'BC', label: 'British Columbia', canada: true },
  { abbr: 'MB', label: 'Manitoba', canada: true },
  { abbr: 'NB', label: 'New Brunswick', canada: true },
  { abbr: 'NL', label: 'Newfoundland and Labrador', canada: true },
  { abbr: 'NL', label: 'Newfoundland', canada: true },
  { abbr: 'NS', label: 'Nova Scotia', canada: true },
  { abbr: 'NT', label: 'Northwest Territories', canada: true },
  { abbr: 'NU', label: 'Nunavul', canada: true },
  { abbr: 'ON', label: 'Ontario', canada: true },
  { abbr: 'PE', label: 'Prince Edward Island', canada: true },
  { abbr: 'QC', label: 'Quebec', canada: true },
  { abbr: 'SK', label: 'Saskatchewan', canada: true },
  { abbr: 'YT', label: 'Yukon', canada: true }
]


export const getHeaders = () => {
  return new HttpHeaders({ }).set('Authorization', `Bearer ${localStorage.getItem('jwt')}`)
}
